import clone from 'lodash/clone'

// const requireAPI = require.context('./api', false, /\.js$/) // Get js files inside routes folder
const apis = import.meta.glob('./api/*.js', { eager: true })

// Dependency injection function
function withHttp(obj, http) {
	return new Proxy(obj, {
		get: function (target, prop, receiver) {
			if (typeof target[prop] === 'function') {
				return function (...args) {
					return target[prop].bind({ http: http })(...args)
				}
			} else {
				return Reflect.get(...arguments)
			}
		}
	})
}
class APIs {
	constructor(http) {
		if (!http) throw new Error('http is required')

		const keys = Object.keys(apis)
		// console.log(apis)
		// 执行批量替换操作
		for (let path of keys) {
			// 裁剪字符串方式得到路径中的文件名（无扩展名）
			let name = clone(path)
			name = name.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('.js'))
			const module = apis[path].default
			const apiProxied = withHttp(module, http)
			apis[name] = apiProxied
			delete apis[path]
		}
		return apis
	}
}
export default APIs
